export const core_config_version = "0.0.6";
